import { createAction } from 'redux-starter-kit';

/**
 * An action creator for replacing all packages in the state
 * @param {object[]} outcomes A list of packages.
 * @example dispatch(putPackages(outcomes))
 */
export const putPackages = createAction('PUT_PACKAGES');

/**
 * An action creator for putting/replacing a package in the state
 * @param {object} package A list of outcomes.
 * @example dispatch(putPackage(package))
 */
export const putPackage = createAction('PUT_PACKAGE');

/**
 * An action create for putting/replaciong the credit usages for a specific package
 */
export const putCreditUsages = createAction('PUT_CREDIT_USAGES');
